import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/UserCornerInfo`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	cultureCode: string;
	firstName: string;
	lastName: string;
	profilePicture: Image | null;
};

export type Image = {
	id: string;
	url: string;
	availableSizes: number[];
};
